exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog .v-card__text[data-v-4192d458]{padding:0!important}.v-dialog .v-alert[data-v-4192d458]{border-radius:0!important}.v-dialog[data-v-4192d458],.v-dialog .v-card__text[data-v-4192d458]{overflow:hidden!important}.delete[data-v-4192d458]:hover{color:#f44336}.dataTable[data-v-4192d458]{border-bottom:1px solid rgba(0,0,0,.12);border-radius:0}.dataTable .v-data-table-header tr th span[data-v-4192d458]{font-size:14px!important}.edit[data-v-4192d458]:hover{color:#009efb}a[data-v-4192d458]{text-decoration:none}.td-actions[data-v-4192d458]{width:17%}", ""]);

// exports
